<template>
	<div></div>
</template>

<script>
import SessionCheck from "@/api/auth/SessionCheck";
import PopUp from "@/vue/common/PopUp";
import Login from "@/vue/auth/Login";
import {mapState} from "vuex";
import {isDefined} from "@/helper/Value";

export default {
	components: {
		Login,
		PopUp
	},

	beforeDestroy ()
	{
		this.stopCheck();
	},

	computed: {
		...mapState('auth', {
			'application': 'application',
			'customer': 'customer',
			'authLoaded': 'loaded'
		})
	},

	methods: {
		async check ()
		{
			const response = await new SessionCheck()
				.call();

			if (!response.data.loggedIn)
			{
				location.href = '/auth/login?autoLogout=1';
			}
		},
		startCheck ()
		{
			this.interval = setInterval(() => this.check(), 30000);
		},
		stopCheck ()
		{
			if (this.interval)
			{
				clearInterval(this.interval);
			}
		},
		startCheckIfNecessary ()
		{
			const applicationIsLoggedIn = isDefined(this.application);
			const customerIsLoggedIn = isDefined(this.customer);

			if (applicationIsLoggedIn || customerIsLoggedIn)
			{
				this.startCheck();
			}
		}
	},

	watch: {
		authLoaded (loaded)
		{
			if (loaded)
			{
				this.startCheckIfNecessary();
			}
		}
	}
}
</script>
